<!-- =========================================================================================
    File Name: ChartPieChart.vue
    Description: Create pie chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div>
      <chartjs-component-doughnut-chart @itemclicked="clickedItem" :height=200 :data="data" :options="options"></chartjs-component-doughnut-chart>
  </div>

</template>

<script>
import ChartjsComponentDoughnutChart from "./ChartjsComponentDoughnutChart.vue"
export default {
  data() {
    return {
        
    }
  },
  methods:{
    clickedItem(event,item){
      this.$emit('DoughnutChartClicked',event,item)
    }
  },
  components: {
    ChartjsComponentDoughnutChart
  },
  props:{
    data:{ 
      type:Object,
      required:true,
    },
    options:{
      type:Object,
      required:true,
    }
  }
}
</script>